export default {
	namespaced: true,
	state: {
		loans: [],
	},

	mutations:{
		setLoans(state, payload) {
			state.loans=payload
		},
	},
	getters:{
		getLoans (state) {
			return state.loans
		},
	},
	actions: {

	},

}